import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  background: var(--Shades-50, #f0f0f5);
  padding: 40px 20px !important;
  gap: 32px;
  margin: 0px auto !important;
  max-width: 1440px !important;
  ${media.md`
    padding: 60px 44px !important;
    gap: 40px;
  `}
  ${media.lg`
    padding: 60px !important;
    background: var(--Shades-0, #fff);
  `}

  ${media.xl`
    padding: 80px !important;
    
  `}
`;

export const StyledContentBlock = styled.div`
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px !important;
`;

export const MainTitle = styled.h2`
  color: #1c1c1c;
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: 40px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 60px;
    font-style: normal;
    line-height: 90%; /* 54px */
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    line-height: 85%;
    letter-spacing: -1.4px;
    
  `}
`;

export const MainContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 32px 0px 12px;

  ${media.md`
    padding: 0px;
    margin: 40px 0px 0px;
  `}
`;

export const MainText = styled.p`
  color: var(--Shades-700, #67656e);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;
  line-height: 135%;
  margin: 0px;

  ${media.md`
    flex: 1 0 0;
    font-size: 18px;
    line-height: 150%; 
  `}
  ${media.xl`
    font-size: 22px;
    line-height: 123%; 
    max-width: 584px;
  `}
`;

export const ButtonWrapper = styled.div`
  display: none;
  justify-content: end;
  align-items: center;
  gap: 16px;

  ${media.md`
    display: flex;
  `}
`;

export const RightArrowButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  background: #4169e1;
  border-radius: 116.162px;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  transition: background 0.3s ease, opacity 0.4s ease, transform 0.4s ease;
  opacity: ${props => (props.visible ? 1 : 0)};
  transform: ${props => (props.visible ? 'scale(1)' : 'scale(0.8)')};
  pointer-events: ${props => (props.visible ? 'auto' : 'none')};

  &:hover {
    background: #2048c1;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1s ease-out;
    background-color: rgba(24, 49, 133, 0.7);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;

export const LeftArrowButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  background: #4169e1;
  border-radius: 116.162px;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  transition: background 0.3s ease, opacity 0.4s ease, transform 0.4s ease;
  opacity: ${props => (props.visible ? 1 : 0)};
  transform: ${props => (props.visible ? 'scale(1)' : 'scale(0.8)')};
  pointer-events: ${props => (props.visible ? 'auto' : 'none')};

  &:hover {
    background: #2048c1;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1s ease-out;
    background-color: rgba(24, 49, 133, 0.7);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;

export const CardContainer = styled.div`
  cursor: pointer;
  position: relative;
`;

export const CardWrapper = styled.div`
  display: flex;
  align-items: stretch;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 18px;
  margin: 0px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  align-self: stretch;
  cursor: pointer;
  height: 100%;
  ${media.lg`
    gap: var(--radius-reg, 40px);
    
  `}
`;

export const ImageContainer = styled.div`
  background: var(--Shades-100, #c5c2cc);

  align-self: stretch;
  width: 260px;
  height: 219px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: visible;
  margin-top: 20px;

  ${media.md`
    width: 305px;
    height: 248px;
    margin-top: 40px;
    
  `};
  ${media.lg`
    width: 415px;
    border-radius: 12.639px;
    background: var(--Grey-Scale-50, #f0f0f5);
    flex: 1 0 0;
    height: 337px;
    margin-top: 50px;
    
  `};
`;

export const CardImage = styled.img`
  display: flex;
  width: 238px;
  height: 190px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  object-fit: contain;
  left: 5px;
  top: -10px;

  ${media.md`
    width: 278px;
    height: 231px;
    top: -20px;
    
  `};
  ${media.lg`
    width: 392px;
    height: 318.412px;
    top: -30px;
    
  `};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  align-self: stretch;

  background: var(--Primary-White-Paper, #fff);
  gap: 24px;
  padding: 20px;
  height: 100%;
  flex: 1 0 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  ${media.md`
   
    padding: 32px;
    
  `};
  ${media.lg`
    gap: unset;
    border-radius: 10px;
    padding: unset;
   

    
  `};
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  gap: 16px;
  align-self: stretch;
  ${media.lg`
    gap: var(--radius-sml, 20px);
   

    
  `};
`;

export const CardTitle = styled.h3`
  color: #1c1c1c;
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: 28px;
  line-height: 85%; /* 23.8px */
  letter-spacing: -0.56px;
  text-transform: uppercase;
  margin: 0px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};

  ${media.md`
    font-size: 34px;
    font-style: normal;
    line-height: 89%; 
    letter-spacing: -0.68px;
  `}

  ${media.xl`
    font-size: 46px;
    line-height: 85%;
    letter-spacing: -0.92px;
    width: 90%;
    
  `}
`;

export const CardText = styled.p`
  color: #797b8b;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  margin: 0px;

  ${media.md`
    font-size: 16px;
    line-height: 150%;

  `}
  ${media.lg`
    width:90%;
  `}
`;

export const CardButton = styled.button`
  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 9.293px;
  border-radius: 116.162px;
  background: var(--orange-500, #ff9500);
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--Grey-Scale-900, #1c1c1c);
  text-align: center;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  cursor: pointer;
  width: 80%;
  border: none;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;
  border: none !important;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  ${media.md`
  
    padding: 14px 24px;
    font-size: 18px;
    margin-top:10px;
    
    
  `}
  ${media.lg`
    
    font-size: 18px;
    width:unset;
    margin-top:20px;
  `} 
  ${media.xl`
    
    font-size: 20px;
    padding: 14px 27.879px;
  `};
`;
